import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { EventDetailComponent } from './event-detail/event-detail.component';
import { EventsComponent } from "./events/events.component";

@Component({
  selector: 'app-root',
  imports: [RouterModule],
  standalone:true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'partnersmeet';
  showHome = false;
    constructor(
      private router: Router,
      private route: ActivatedRoute  
    ){
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          console.log('Navigation started to:', event.url);
        }
  
        if (event instanceof NavigationEnd) {
          if(event.url == '/'){
            this.showHome = false;
          } else {
            this.showHome = true;
          }
          console.log('Navigation ended at:', event.url);
        }
  
        if (event instanceof NavigationError) {
          console.log('Navigation error occurred:', event.error);
        }
      });
    }
  redirectTo(){
    this.router.navigate(['/']);  // Redirects to 'item/123'

  }
}
